(function () {
    "use strict";

    // Customer Club Tab switching in My Account page
    document.addEventListener('click', function (e) {
        const tabLink = e.target.closest('.ns-club-tab-link');
        if (tabLink) {
            e.preventDefault();
            const target = tabLink.getAttribute('data-tab');

            document.querySelectorAll('.ns-club-tab-link').forEach(el => el.classList.remove('active'));
            tabLink.classList.add('active');

            document.querySelectorAll('.ns-club-tab-content').forEach(el => el.style.display = 'none');
            const targetContent = document.getElementById('ns-club-tab-' + target);
            if (targetContent) {
                targetContent.style.display = 'block';
                targetContent.animate([
                    { opacity: 0 },
                    { opacity: 1 }
                ], { duration: 150 });
            }
            return;
        }

        // Copy Referral Link
        const copyBtn = e.target.closest('#ns-copy-ref-link');
        if (copyBtn) {
            e.preventDefault();
            const copyText = document.getElementById("ns-ref-link-input");
            if (copyText) {
                copyText.select();
                copyText.setSelectionRange(0, 99999);
                navigator.clipboard.writeText(copyText.value).then(function () {
                    alert("لینک دعوت اختصاصی شما کپی شد!");
                }).catch(function () {
                    document.execCommand("copy");
                    alert("لینک دعوت اختصاصی شما کپی شد!");
                });
            }
            return;
        }

        // Claim Reward
        const claimBtn = e.target.closest('.ns-claim-reward-btn');
        if (claimBtn) {
            e.preventDefault();
            const rewardId = claimBtn.getAttribute('data-id');
            const nonce = claimBtn.getAttribute('data-nonce');

            if (!confirm('آیا از دریافت این جایزه با کسر امتیاز اطمینان دارید؟')) {
                return;
            }

            claimBtn.disabled = true;
            claimBtn.textContent = 'در حال دریافت...';

            const formData = new URLSearchParams();
            formData.append('action', 'negarshop_claim_reward');
            formData.append('reward_id', rewardId);
            formData.append('security', nonce);

            fetch(NS_OBJ.ajax_url, {
                method: 'POST',
                body: formData,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            })
            .then(res => res.json())
            .then(response => {
                if (response.success) {
                    alert('جایزه با موفقیت دریافت شد! کد تخفیف شما: ' + response.data.coupon_code);
                    window.location.reload();
                } else {
                    alert(response.data.message);
                    claimBtn.disabled = false;
                    claimBtn.textContent = 'دریافت جایزه';
                }
            })
            .catch(err => {
                console.error(err);
                alert('خطایی رخ داد. لطفا مجددا تلاش کنید.');
                claimBtn.disabled = false;
                claimBtn.textContent = 'دریافت جایزه';
            });
            return;
        }

        // Save Birthday Info
        const saveBirthdayBtn = e.target.closest('#ns-save-birthday-btn');
        if (saveBirthdayBtn) {
            e.preventDefault();
            const birthdayInput = document.getElementById('ns-birthday-input');
            const birthdayVal = birthdayInput ? birthdayInput.value : '';
            const nonce = saveBirthdayBtn.getAttribute('data-nonce');

            if (!birthdayVal) {
                alert('لطفا تاریخ تولد خود را وارد کنید.');
                return;
            }

            saveBirthdayBtn.disabled = true;
            saveBirthdayBtn.textContent = 'در حال ثبت...';

            const formData = new URLSearchParams();
            formData.append('action', 'negarshop_save_birthday');
            formData.append('birthday', birthdayVal);
            formData.append('security', nonce);

            fetch(NS_OBJ.ajax_url, {
                method: 'POST',
                body: formData,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            })
            .then(res => res.json())
            .then(response => {
                if (response.success) {
                    alert(response.data.message);
                    window.location.reload();
                } else {
                    alert(response.data.message);
                    saveBirthdayBtn.disabled = false;
                    saveBirthdayBtn.textContent = 'ثبت تاریخ تولد';
                }
            })
            .catch(err => {
                console.error(err);
                alert('خطایی رخ داد. لطفا مجددا تلاش کنید.');
                saveBirthdayBtn.disabled = false;
                saveBirthdayBtn.textContent = 'ثبت تاریخ تولد';
            });
            return;
        }
    });
})();
